var _rect, _rect2, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetaBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 19.5,
    fill: "#F8F8F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 19.5,
    stroke: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7003 32.6481C20.7003 33.6027 20.9097 34.3356 21.1837 34.7789C21.5428 35.3597 22.0783 35.6062 22.6243 35.6062C23.3284 35.6062 23.9727 35.4314 25.2141 33.7144C26.2089 32.3382 27.3806 30.4064 28.1692 29.1953L29.5045 27.1436C30.4321 25.7187 31.5058 24.1347 32.7369 23.061C33.7422 22.1846 34.8261 21.6978 35.9171 21.6978C37.749 21.6978 39.4938 22.7593 40.8292 24.7502C42.2906 26.9306 43 29.677 43 32.5111C43 34.1961 42.6679 35.4341 42.1028 36.4121C41.5569 37.358 40.4927 38.3031 38.7026 38.3031V35.6058C40.2354 35.6058 40.6179 34.1973 40.6179 32.5855C40.6179 30.2886 40.0823 27.7396 38.9026 25.9182C38.0654 24.6263 36.9804 23.837 35.7867 23.837C34.4957 23.837 33.4567 24.8108 32.2891 26.5468C31.6684 27.4692 31.0311 28.5933 30.3156 29.8618L29.5279 31.2571C27.9458 34.0631 27.5449 34.7019 26.7538 35.7562C25.3672 37.6026 24.183 38.3026 22.6243 38.3026C20.7751 38.3026 19.6058 37.5018 18.8815 36.2952C18.2904 35.312 18 34.0217 18 32.5517L20.7003 32.6481Z",
    fill: "#0081FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1292 24.9399C21.3671 23.0316 23.1538 21.697 25.2029 21.697C26.3896 21.697 27.5695 22.0482 28.8013 23.0542C30.1488 24.1537 31.585 25.9654 33.3768 28.9499L34.0193 30.0206C35.5703 32.6045 36.4527 33.9338 36.9691 34.5606C37.6333 35.3656 38.0984 35.6056 38.7026 35.6056C40.2354 35.6056 40.6179 34.1971 40.6179 32.5853L43 32.5105C43 34.1955 42.6679 35.4334 42.1028 36.4115C41.5569 37.3573 40.4927 38.3024 38.7026 38.3024C37.5898 38.3024 36.604 38.0607 35.5137 37.0322C34.676 36.2428 33.6958 34.8405 32.9421 33.5799L30.6999 29.8346C29.575 27.955 28.5427 26.5536 27.9458 25.9189C27.3032 25.2363 26.4773 24.4122 25.1593 24.4122C24.0927 24.4122 23.1867 25.1607 22.4287 26.3057L20.1292 24.9399Z",
    fill: "url(#paint0_linear_679_146960)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1593 24.4122C24.0927 24.4122 23.1867 25.1607 22.4287 26.3057C21.3567 27.9236 20.7008 30.3335 20.7008 32.6478C20.7008 33.6024 20.9102 34.3353 21.1842 34.7786L18.8815 36.2949C18.2904 35.3117 18 34.0214 18 32.5514C18 29.878 18.7338 27.0916 20.1291 24.9399C21.3671 23.0316 23.1537 21.697 25.2029 21.697L25.1593 24.4122Z",
    fill: "url(#paint1_linear_679_146960)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_679_146960",
    x1: 23.4194,
    y1: 29.5694,
    x2: 40.6331,
    y2: 30.4388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0073EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_679_146960",
    x1: 21.6014,
    y1: 33.7815,
    x2: 21.6014,
    y2: 27.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaBtn);
export default __webpack_public_path__ + "static/media/meta-btn.d8fb72b498ffe5df73091099feef491e.svg";
export { ForwardRef as ReactComponent };